module.exports = __webpack_public_path__ + "static/media/2.8a26ad75.png";